// The default atob and btoa don't support certain characters

export function encodeBase64(value: string): string {
    return btoa(
        encodeURIComponent(value).replace(
            /%([0-9A-F]{2})/g,
            (_match, p1) => String.fromCharCode(parseInt('0x' + p1, 16))
        )
    );
}

export function decodeBase64(value: string): string {
    return decodeURIComponent(
        atob(value)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/base64.ts